var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 18C4.04 18 0 13.96 0 9C0 4.04 4.04 0 9 0C13.96 0 18 4.04 18 9C18 13.96 13.96 18 9 18ZM9 1.5C4.86 1.5 1.5 4.86 1.5 9C1.5 13.14 4.86 16.5 9 16.5C13.14 16.5 16.5 13.14 16.5 9C16.5 4.86 13.14 1.5 9 1.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2999 12.12C11.1099 12.12 10.9199 12.05 10.7799 11.91L8.3799 9.58999C8.2299 9.44999 8.1499 9.24999 8.1499 9.04999V3.79999C8.1499 3.38999 8.4899 3.04999 8.8999 3.04999C9.3099 3.04999 9.6499 3.38999 9.6499 3.79999V8.72999L11.8199 10.83C12.1199 11.12 12.1299 11.59 11.8399 11.89C11.6899 12.04 11.4999 12.12 11.2999 12.12Z",
    fill: "currentColor",
    className: "accent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.316c88534e3929dd9aa4267e607661d0.svg";
export { ForwardRef as ReactComponent };